"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOlarkLocalConfig = void 0;
const next_i18next_1 = require("next-i18next");
const useOlarkLocalConfig = () => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    return {
        away_message: t('chat.away_message'),
        before_chat_text: t('chat.before_chat_text'),
        branding_link_text: t('chat.branding_link_text'),
        branding_panel_cancel_text: t('chat.branding_panel_cancel_text'),
        branding_panel_link_text: t('chat.branding_panel_link_text'),
        branding_panel_message_text: t('chat.branding_panel_message_text'),
        chat_input_text: t('chat.chat_input_text'),
        chatting_title: t('chat.chatting_title'),
        cobrowsing_allow_approve_button_stop: t('chat.cobrowsing_allow_approve_button_stop'),
        cobrowsing_confirm_control_text: t('chat.cobrowsing_confirm_control_text'),
        cobrowsing_notify_visitor_browser_not_supported: t('chat.cobrowsing_notify_visitor_browser_not_supported'),
        cobrowsing_notify_visitor_control_text: t('chat.cobrowsing_notify_visitor_control_text'),
        cobrowsing_notify_visitor_end_text: t('chat.cobrowsing_notify_visitor_end_text'),
        cobrowsing_visitor_allow_approve_message: t('chat.cobrowsing_visitor_allow_approve_message'),
        cobrowsing_visitor_confirm_allow_button_decline: t('chat.cobrowsing_visitor_confirm_allow_button_decline'),
        cobrowsing_visitor_confirm_allow_button_start: t('chat.cobrowsing_visitor_confirm_allow_button_start'),
        cobrowsing_visitor_confirm_allow_message: t('chat.cobrowsing_visitor_confirm_allow_message'),
        cobrowsing_visitor_decline_text: t('chat.cobrowsing_visitor_decline_text'),
        conversation_id_error_text: t('chat.conversation_id_error_text'),
        dismiss_message_text: t('chat.dismiss_message_text'),
        email_body_error_text: t('chat.email_body_error_text'),
        email_input_text: t('chat.email_input_text'),
        end_chat_button_text: t('chat.end_chat_button_text'),
        ended_chat_message: t('chat.ended_chat_message'),
        feedback_survey_begin_button_text: t('chat.feedback_survey_begin_button_text'),
        feedback_survey_button_finish: t('chat.feedback_survey_button_finish'),
        feedback_survey_button_next: t('chat.feedback_survey_button_next'),
        feedback_survey_button_submitting: t('chat.feedback_survey_button_submitting'),
        feedback_survey_cancel_text: t('chat.feedback_survey_cancel_text'),
        feedback_survey_complete_button_text: t('chat.feedback_survey_complete_button_text'),
        feedback_survey_end_message: t('chat.feedback_survey_end_message'),
        feedback_survey_question_1_text: t('chat.feedback_survey_question_1_text'),
        feedback_survey_question_2_text: t('chat.feedback_survey_question_2_text'),
        feedback_survey_question_3_text: t('chat.feedback_survey_question_3_text'),
        feedback_survey_question_4_text: t('chat.feedback_survey_question_4_text'),
        feedback_survey_question_5_text: t('chat.feedback_survey_question_5_text'),
        feedback_survey_question_additional_feedback_placeholder: t('chat.feedback_survey_question_additional_feedback_placeholder'),
        feedback_survey_question_additional_feedback_text: t('chat.feedback_survey_question_additional_feedback_text'),
        feedback_survey_question_chat_high: t('chat.feedback_survey_question_chat_high'),
        feedback_survey_question_chat_low: t('chat.feedback_survey_question_chat_low'),
        feedback_survey_question_chat_text: t('chat.feedback_survey_question_chat_text'),
        feedback_survey_question_operator_attitude_high: t('chat.feedback_survey_question_operator_attitude_high'),
        feedback_survey_question_operator_attitude_low: t('chat.feedback_survey_question_operator_attitude_low'),
        feedback_survey_question_operator_attitude_text: t('chat.feedback_survey_question_operator_attitude_text'),
        feedback_survey_question_operator_intelligence_high: t('chat.feedback_survey_question_operator_intelligence_high'),
        feedback_survey_question_operator_intelligence_low: t('chat.feedback_survey_question_operator_intelligence_low'),
        feedback_survey_question_operator_intelligence_text: t('chat.feedback_survey_question_operator_intelligence_text'),
        feedback_survey_question_operator_speed_high: t('chat.feedback_survey_question_operator_speed_high'),
        feedback_survey_question_operator_speed_low: t('chat.feedback_survey_question_operator_speed_low'),
        feedback_survey_question_operator_speed_text: t('chat.feedback_survey_question_operator_speed_text'),
        feedback_survey_submission_error_message: t('chat.feedback_survey_submission_error_message'),
        file_size_error_text: t('chat.file_size_error_text'),
        file_type_error_text: t('chat.file_type_error_text'),
        generic_upload_error_text: t('chat.generic_upload_error_text'),
        habla_name_input_text: t('chat.habla_name_input_text'),
        habla_offline_body_text: t('chat.habla_offline_body_text'),
        habla_offline_email_text: t('chat.habla_offline_email_text'),
        habla_offline_phone_text: t('chat.habla_offline_phone_text'),
        habla_offline_sent_text: t('chat.habla_offline_sent_text'),
        habla_offline_submit_value: t('chat.habla_offline_submit_value'),
        in_chat_text: t('chat.in_chat_text'),
        name_input_text: t('chat.name_input_text'),
        not_available_text: t('chat.not_available_text'),
        offline_button_text: t('chat.offline_button_text'),
        offline_email_validation_message: t('chat.offline_email_validation_message'),
        offline_header_text: t('chat.offline_header_text'),
        offline_message: t('chat.offline_message'),
        offline_note_error_text: t('chat.offline_note_error_text'),
        offline_note_message: t('chat.offline_note_message'),
        offline_note_thankyou_text: t('chat.offline_note_thankyou_text'),
        offline_phone_validation_message: t('chat.offline_phone_validation_message'),
        offline_required_error_message: t('chat.offline_required_error_message'),
        offline_survey_email_label: t('chat.offline_survey_email_label'),
        offline_survey_email_placeholder: t('chat.offline_survey_email_placeholder'),
        offline_survey_name_label: t('chat.offline_survey_name_label'),
        offline_survey_name_placeholder: t('chat.offline_survey_name_placeholder'),
        offline_survey_next_button_text: t('chat.offline_survey_next_button_text'),
        offline_survey_phone_label: t('chat.offline_survey_phone_label'),
        offline_survey_phone_placeholder: t('chat.offline_survey_phone_placeholder'),
        offline_survey_submit_button_text: t('chat.offline_survey_submit_button_text'),
        offline_survey_thank_you_message: t('chat.offline_survey_thank_you_message'),
        offline_survey_website_label: t('chat.offline_survey_website_label'),
        offline_survey_website_placeholder: t('chat.offline_survey_website_placeholder'),
        offline_survey_welcome_message: t('chat.offline_survey_welcome_message'),
        offline_website_validation_message: t('chat.offline_website_validation_message'),
        online_button_text: t('chat.online_button_text'),
        online_header_text: t('chat.online_header_text'),
        operator_has_stopped_typing_text: t('chat.operator_has_stopped_typing_text'),
        operator_is_typing_text: t('chat.operator_is_typing_text'),
        phone_input_text: t('chat.phone_input_text'),
        pre_chat_error_text: t('chat.pre_chat_error_text'),
        pre_chat_message: t('chat.pre_chat_message'),
        pre_chat_submit: t('chat.pre_chat_submit'),
        prechat_email_validation_message: t('chat.prechat_email_validation_message'),
        prechat_phone_validation_message: t('chat.prechat_phone_validation_message'),
        prechat_required_error_message: t('chat.prechat_required_error_message'),
        prechat_survey_email_label: t('chat.prechat_survey_email_label'),
        prechat_survey_email_placeholder: t('chat.prechat_survey_email_placeholder'),
        prechat_survey_name_label: t('chat.prechat_survey_name_label'),
        prechat_survey_name_placeholder: t('chat.prechat_survey_name_placeholder'),
        prechat_survey_next_button_text: t('chat.prechat_survey_next_button_text'),
        prechat_survey_phone_label: t('chat.prechat_survey_phone_label'),
        prechat_survey_phone_placeholder: t('chat.prechat_survey_phone_placeholder'),
        prechat_survey_required_fields: t('chat.prechat_survey_required_fields'),
        prechat_survey_submit_button_text: t('chat.prechat_survey_submit_button_text'),
        prechat_survey_website_label: t('chat.prechat_survey_website_label'),
        prechat_survey_website_placeholder: t('chat.prechat_survey_website_placeholder'),
        prechat_survey_welcome_message: t('chat.prechat_survey_welcome_message'),
        prechat_website_validation_message: t('chat.prechat_website_validation_message'),
        processing_file_error_text: t('chat.processing_file_error_text'),
        restart_chat_offline_button_text: t('chat.restart_chat_offline_button_text'),
        restart_chat_online_button_text: t('chat.restart_chat_online_button_text'),
        say_text: t('chat.say_text'),
        send_button_text: t('chat.send_button_text'),
        send_transcript_begin_button_text: t('chat.send_transcript_begin_button_text'),
        send_transcript_cancel_text: t('chat.send_transcript_cancel_text'),
        send_transcript_complete_button_text: t('chat.send_transcript_complete_button_text'),
        send_transcript_error_text: t('chat.send_transcript_error_text'),
        send_transcript_placeholder: t('chat.send_transcript_placeholder'),
        send_transcript_title_text: t('chat.send_transcript_title_text'),
        unavailable_title: t('chat.unavailable_title'),
        upload_rejected_error_text: t('chat.upload_rejected_error_text'),
        visitor_id_error_text: t('chat.visitor_id_error_text'),
        welcome_message: t('chat.welcome_message'),
        welcome_msg: t('chat.welcome_msg'),
    };
};
exports.useOlarkLocalConfig = useOlarkLocalConfig;
//# sourceMappingURL=useOlarkLocalConfig.js.map